import { lazy } from 'react';

const LoginPage = lazy(() => import('../pages/Login.page'));

export const LoginRoutes = [
    {
        path: '/login',
        element: <LoginPage />,
    },
];
